<template>
  <div>
    <div class="casino-page-header">
      <div class="group-header casino-page-header-item">
        <h2 v-if="groupTitle && !specialGroupType" class="group-name">{{$t(`${groupTitle}`)}}</h2>
        <div v-if="specialGroupType && !['CasinoMarketingJackpots'].includes(specialGroupType)" class="casino-page-logo-title">
          <img class="logo-holder-image" :src="mediaServer('/static/casino/groups/' + groupData.externalId + '/assets/logo/' + groupData.externalId + '.svg')" alt="" loading="lazy" />
        </div>
      </div>
      <casino-tabs class="casino-page-header-item" @sortTypeSelected="sortGames" @filterSelected="filterSelected" :setDefaultTab="1" :section="'filterAndSort'" :pageType="groupSlug" :itemCount="originalPreparedData && originalPreparedData.length" :providers="providers" :themeList="themeList" :filteredItems="filteredItems" :originalPreparedData="originalPreparedData" :selectedFilterNumberDisplay="selectedFilterNumberDisplay"></casino-tabs>
    </div>
    <template v-if="specialGroupType">
      <component :is="specialGroupType" :group="groupData" :groupRender="false" :gridView="true" :key="componentKey"></component>
    </template>
    <template v-else>
      <div v-if="!groupData || groupData.gameIds.length === 0" class="no-games-in-list">{{$t('Casino.No.Games')}}</div>
      <casino-grid-view v-if="groupData" :data="filterGamesInfoDataByGroup(this.groupData.gameIds)" :groupData="groupData" :key="componentKey"></casino-grid-view>
    </template>
  </div>
</template>
<script>
import Casino from '@/components/mixins/Casino'
import CasinoGridView from '@/components/igaming/partials/casinoGridView.vue'
import CasinoMarketingJackpots from '@/components/igaming/partials/casinoMarketingJackpots.vue'
import CasinoTopGames from '@/components/igaming/partials/casinoTopGames.vue'
import CasinoTabs from '@/components/igaming/partials/casinoTabs.vue'
import Url from '@/components/mixins/Url'
import store from '@/store'
export default {
  name: 'casinoPage',
  mixins: [
    Casino,
    Url
  ],
  props: [],
  components: {
    CasinoGridView,
    CasinoMarketingJackpots,
    CasinoTabs,
    CasinoTopGames
  },
  data () {
    return {
      groupData: false,
      preparedData: null,
      originalPreparedData: null,
      componentKey: null,
      specialGroupType: undefined,
      groupTitle: false,
      themeList: false,
      methodMap: {
        'recently-played': 'fetchUserRecentlyPlayedGames',
        'recommended-games': 'fetchRecommendedGames',
        'favorite-games': 'fetchAllFavoriteGames'
      },
      isLoaded: false,
      titleTranslation: {
        'recently-played': 'Casino.User.Recently.Played.Games',
        'recommended-games': 'Casino.User.Recommended.Games',
        'favorite-games': 'Casino.User.Favorite.Games'
      },
      filteredItems: false,
      selectedFilterNumberDisplay: false
    }
  },
  computed: {
    groupId () {
      return this.$route.params.groupId
    },
    groupSlug () {
      return this.$route.params.slug
    },
    allGames () {
      return store.getters['gap/getAllGamesData']
    },
    favoriteGames () {
      return store.getters['gap/getFavoriteGames']
    },
    providers () {
      return store.getters['gap/getProviders']
    }
  },
  methods: {
    fetchGroupData () {
      if (this.methodMap[this.groupSlug]) {
        store.dispatch(`gap/${this.methodMap[this.groupSlug]}`).then(response => {
          this.groupData = this.setGroupSliderItemLimit(response, true)
          this.componentKey = Math.random()
          if (this.groupData) {
            this.groupTitle = this.titleTranslation[this.groupSlug]
            this.prepareGameData()
          }
        }).catch(error => {
          console.log('casino - fetch group data error:', error)
        })
        return false
      }
      let data = this.groupSlug
      this.groupData = this.findGroupData(data || null)
      this.componentKey = Math.random()
      this.groupTitle = this.groupData.groupName
      if (this.groupData) {
        this.prepareGameData()
      }
    },
    prepareGameData () {
      this.preparedData = []
      this.originalPreparedData = []
      if (this.groupData && this.allGames && Array.isArray(this.groupData.gameIds) && Array.isArray(this.allGames.games)) {
        this.groupData.gameIds.forEach(gameId => {
          const gameObj = this.allGames.games.find(g => String(g.id) === String(gameId))
          if (gameObj) {
            this.preparedData.push(gameObj)
            this.originalPreparedData.push(gameObj)
          }
        })
      }
      this.themeList = this.getThemeListByCasinoPage(this.preparedData)
      this.isLoaded = true
    }
  },
  mounted () {
    if (this.allGames) {
      this.fetchGroupData()
    }
  },
  watch: {
    groupSlug (newVal) {
      if (newVal) {
        this.fetchGroupData()
      }
    },
    allGames (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.fetchGroupData()
      }
    },
    groupData (newVal) {
      if (newVal) this.checkIsSpecialGroupType(this.groupData.type, this.groupData.groupId)
    },
    favoriteGames (newVal) {
      if (this.isLoaded && newVal && this.groupSlug === 'favorite-games' && this.isLoggedIn) {
        this.groupData = this.setGroupSliderItemLimit(newVal, true)
        this.componentKey = Math.random()
        if (this.data) {
          this.prepareGameData()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/CasinoPage.vue